<template>
  <div style="width: 100%">
    <iframe
      width="100%"
      height="400"
      frameborder="0"
      scrolling="no"
      marginheight="0"
      marginwidth="0"
      :src="`https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=${this.location}+(${this.schoolName})&amp;t=&amp;z=17&amp;ie=UTF8&amp;iwloc=B&amp;output=embed`"
    />
  </div>
</template>
<script>
export default {
  name: "AddGoogleMap",
  props: {
    location: {
      type: String,
      default: ''
    },
    schoolName: {
      type: String,
      default: ''
    }
  },
};
</script>
